/**
 * The stylesheets every `/orca/v3` page links from its `head()`: the orcaloops v5 frame,
 * the v3 additions, then the run page's own sheets — the Layers and lanes, the chain /
 * map / board views, the right panel, and the top bar's chip and story.
 *
 * @since 1.0.0
 */
import v3BarCss from "~/components/v3/v3-bar.css?url";
import v3LayersCss from "~/components/v3/v3-layers.css?url";
import v3PanelCss from "~/components/v3/v3-panel.css?url";
import v3ViewsCss from "~/components/v3/v3-views.css?url";
import v3Css from "~/components/v3/v3.css?url";
import type { HeadLink } from "~/config/head.ts";
import { orcaloopsStylesheetLinks } from "./orcaloops-head.ts";

/**
 * @since 1.0.0
 */
export const v3StylesheetLinks: Array<HeadLink> = [
  ...orcaloopsStylesheetLinks,
  { rel: "stylesheet", href: v3Css },
  { rel: "stylesheet", href: v3LayersCss },
  { rel: "stylesheet", href: v3ViewsCss },
  { rel: "stylesheet", href: v3PanelCss },
  { rel: "stylesheet", href: v3BarCss },
];
